import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { CANADA_PROVINCE_SHORTHAND_TO_NAME } from "./CANADA_PROVINCE_SHORTHAND_TO_NAME";
import { US_STATE_SHORTHAND_TO_NAME } from "./US_STATE_SHORTHAND_TO_NAME";
export var STATE_PROVINCE_SHORTHAND_TO_NAME = function(strictLocalize) {
    return _object_spread({}, US_STATE_SHORTHAND_TO_NAME(strictLocalize), CANADA_PROVINCE_SHORTHAND_TO_NAME(strictLocalize));
};
